import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './WaitingStatuses.translations.json';
import React, { FC, useMemo } from 'react';
import { DashboardPanel } from '../DashboardPanel';
import { keepPreviousData } from '@tanstack/react-query';
import { useGetWaitingStatusesQuery } from './query/useGetWaitingStatusesQuery';
import { Flex } from 'antd';
import { InfoIconUrl, Tooltip } from '../../common/components';
import { WaitingStatusesDto } from './schema/types';
import { Table } from '../../common/tanstacktable';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { GroupedValueDates } from '../GroupedValueDates';

const { addTranslations, t } = i18nNsFactory('waiting-statuses');
addTranslations(translations);

export const WaitingStatuses = () => {
  const { data: waitingStatuses = [], isLoading } = useGetWaitingStatusesQuery({
    placeholderData: keepPreviousData,
  });

  return (
    <DashboardPanel
      title={t('title')}
      infoIconUrl={InfoIconUrl.WAITING_STATUSES}
      isLoading={isLoading}
      isEmpty={!waitingStatuses.length}
      modalContent={<WaitingStatusModalContent items={waitingStatuses} />}
    >
      <Flex gap="small" vertical>
        {waitingStatuses.map((status) => {
          return (
            <Flex key={status.id}>
              <Tooltip
                title={
                  <GroupedValueDates
                    frequencyId={status.frequencyId}
                    valueDates={status.valueDates}
                    separator={
                      <>
                        ,<br />
                      </>
                    }
                  />
                }
              >
                {status.name}
              </Tooltip>
            </Flex>
          );
        })}
      </Flex>
    </DashboardPanel>
  );
};

const columnHelper = createColumnHelper<WaitingStatusesDto>();
export const WaitingStatusModalContent: FC<{
  items: WaitingStatusesDto[];
}> = ({ items }) => {
  const columns = useMemo(() => {
    const columns: ColumnDef<WaitingStatusesDto, any>[] = [
      columnHelper.accessor('name', {
        header: t('name.label'),
      }),
      columnHelper.accessor('valueDates', {
        header: t('valueDates.label'),
        enableSorting: false,
        enableColumnFilter: false,
        cell: (props) => (
          <GroupedValueDates
            frequencyId={props.row.original.frequencyId}
            valueDates={props.row.original.valueDates}
            separator={', '}
          />
        ),
      }),
    ];

    return columns;
  }, []);

  return (
    <Table
      name="waiting-statuses-table"
      columns={columns}
      data={items}
      hideClearFilters
      columnOrderingDisabled={true}
      columnResizeDisabled={true}
    />
  );
};
